<template>
    <div>
        <p class="order-info-label">{{ title }}</p>
        <div class="order-info-grid">
            <template v-for="(row, index) in rows" :key="`${row.label}-${index}`">
                <div v-if="row.value" class="order-info-row">
                    <span class="order-info-row-label">{{ row.label }}</span>

                    <button v-if="row.copyKey && onCopy" type="button"
                        class="order-info-value order-info-value-copy"
                        :title="copiedKey === row.copyKey ? 'Copied!' : `Copy ${row.label.replace(/#\s*$/, '').trim().toLowerCase()}`"
                        @click="onCopy(row.copyKey, row.value)">
                        <span :class="{ 'order-info-mono': row.mono }">{{ row.value }}</span>
                        <Check v-if="copiedKey === row.copyKey" class="w-3.5 h-3.5" />
                        <Copy v-else class="w-3.5 h-3.5" />
                    </button>

                    <span v-else class="order-info-value" :class="{ 'order-info-mono': row.mono }">
                        {{ row.value }}
                    </span>
                </div>
            </template>
        </div>
    </div>
</template>

<script setup>
import { Check, Copy } from "lucide-vue-next";

defineProps({
    title: {
        type: String,
        default: "Order Information",
    },
    rows: {
        type: Array,
        default: () => [],
    },
    copiedKey: {
        type: String,
        default: "",
    },
    onCopy: {
        type: Function,
        default: null,
    },
});
</script>

<style scoped>
.order-info-label {
    margin: 0 0 10px;
    font-size: 11px;
    font-weight: 600;
    color: #8c95a6;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.order-info-grid {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.order-info-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    font-size: 13px;
}

.order-info-row-label {
    color: #6d7688;
}

.order-info-value {
    color: #242c3a;
    font-weight: 600;
    text-align: right;
}

.order-info-value-copy {
    background: transparent;
    border: none;
    padding: 0;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.order-info-value-copy svg {
    color: #8a93a5;
}

.order-info-mono {
    /* font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; */
    letter-spacing: 0.02em;
}
</style>
